import React, { useEffect, useState } from 'react'

const addresses = {
  DEFAULT: {
    text: 'Mobilio LTD, a United Kingdom company, is registered at Office 7 35/37, Ludgate Hill, London, United Kingdom, EC4M 7JN.',
  },
  US: {
    text: 'Jomapp LLC, 155 Office Plaza Drive , Tallahassee, FL ,USA, 32301',
  },
  EU: {
    text: 'SHANOVO LTD, Limassol, Cyprus',
  },
}

export const PolicyAddress = () => {
  const [address, setAddress] = useState(addresses.DEFAULT.text)

  useEffect(() => {
    const region = localStorage.getItem('region') || 'US'

    if (region === 'US') {
      setAddress(addresses.US.text)
    } else if (region === 'EU') {
      setAddress(addresses.EU.text)
    } else {
      setAddress(addresses.DEFAULT.text)
    }
  }, [])

  return <p className="mt-5 max-w-[300px] mx-auto text-center text-[10px]">{address}</p>
}
